export default (node) => {
  /**
   * Data + elements
   */
  const headerButtons = node.querySelectorAll('[data-account-header-button]');

  /**
   * Functions
   */
  const selectSection = (sectionActive) => {
    const url = window.location.href;
    const urlArray = url.split('?');
    const allSections = document.querySelectorAll('[data-account-section]');

    if (!sectionActive) {
      if (urlArray.length > 1) {
        sectionActive = urlArray[1];
      }
    }

    if (!sectionActive) {
      if (window.customer.isChattersCustomer) {
        sectionActive = 'collection';
      } else {
        sectionActive = 'orders';
      }
    }

    headerButtons.forEach((button) => {
      button.classList.remove('group-active');

      const buttonActive = button.getAttribute(`data-account-header-button`);
      if (buttonActive && buttonActive === sectionActive) {
        if (buttonActive) button.classList.add('group-active');
        // update url
        const newUrl = `${urlArray[0]}?${sectionActive}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
      }
    });

    // active the section according with the url
    allSections.forEach((section) => {
      const checkSection = section.getAttribute('data-account-section');
      if (checkSection === sectionActive) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    });
  };

  /**
   * Init
   */
  const init = () => {
    // when the page is loaded, we need to check the url to select the correct item in the section header
    selectSection();

    headerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const sectionActive = button.getAttribute('data-account-header-button');
        selectSection(sectionActive);
      });
    });

    // check if the redirectUrl is set in the local storage
    const redirectUrl = localStorage.getItem('redirectUrl');
    if (redirectUrl) {
      localStorage.removeItem('redirectUrl');
      window.location.href = redirectUrl;
    }
  };

  init();
};
